import React from 'react';
// Data
import {
  aboutPageAdditionalMeta,
  aboutPageStructuredData,
} from '../../utils/data/MetaData';
// Components
import Navbar from '../../components/nav/Navbar';
import { HelmetItem } from '../../components/utils/HelmetItem';
import AboutMePageMainContainer from '../../components/about/AboutMePageMainContainer';

function AboutPage() {
  return (
    <>
      {/* Tab Data */}
      <HelmetItem
        PageName='About Lady Cinder'
        desc='Learn about Lady Cinder — the neon-gothic dominatrix and celestial fire deity behind the hypnosis, mindfuck rituals, and divine control. From circus flames to psychological seduction, she reigns as a hypnotic goddess of power and play.'
        keywords='Lady Cinder, About Lady Cinder, Los Angeles dominatrix, neon gothic goddess, hypnotic femdom, fire performer, circus dominatrix, hypnosis queen, sensual sadism, divine feminine power, indoctrination, mind control'
        additionalMeta={aboutPageAdditionalMeta}
        structuredData={aboutPageStructuredData}
      />

      {/* Page */}
      <div className='grid overflow-hidden text-colour1 dark:text-colour1 min-h-screen bg-colour2 dark:bg-colour2 font-poppins'>
        <div className='grid'>
          {/* Navigation */}
          <Navbar />
          <header className='grid py-10 px-6 text-center gap-4 place-items-center'>
            <h1 className='neon_text_heavy_redpink font-titleFont text-4xl md:text-6xl tracking-wider drop-shadow-lg'>
              ABOUT LADY CINDER
            </h1>
            <p className='max-w-2xl text-base md:text-lg leading-relaxed'>
              A neon-gothic dominatrix, hypnotic goddess, and fire deity — Lady
              Cinder is both performer and priestess. Her art fuses hypnosis,
              mindfuck ritual, and celestial theatre into acts of control and
              surrender. A master of psychological seduction and ritual
              performance, she transforms obedience into worship.
            </p>
          </header>

          {/* Main page content */}
          <AboutMePageMainContainer />
        </div>
      </div>
    </>
  );
}

export default AboutPage;
